export const GRAPHQL_VARIABLES = {
  filter: {
    _id: '5fc44a6984ffd06759c1a1e1'
  }
};

export const QUERY = `
  mutation Refund ($id: MongoID!, $amount: Int) {
    invoiceRefund (invoiceId: $id, amount: $amount) {
            _id
            status
            note
            companyId
            createdAt
    }
  }
`;
